import React from "react"
import ProductsPage from "@src/pages/products"

const Home: React.FC = () => {
  return (
    <>
      <ProductsPage />
    </>
  )
}

export default Home
